<template>
  <form class="booking-resume" @submit.prevent="resume">
    <div class="modal-content-generic">
      <div class="content lh-loose">
        <h3>
          Are you sure you want to resume {{ data.booking_type_label }}
          <span class="fg-primary">{{ data.booking_label }}</span>?
        </h3>
      </div>
    </div>
    <div class="modal-actions">
      <div class="action">
        <button type="button" class="button tertiary" @click="keep">
          <svg-icon id="chevronLeft"></svg-icon>
          <span>Keep {{ data.booking_type_label }} on hold</span>
        </button>
      </div>
      <div class="action">
        <loader-button
            type="submit"
            :loading="loading"
            :label="`Resume ${data.type}`"
            class="button primary"
        ></loader-button>
      </div>
    </div>
  </form>
</template>

<script>
import BaseModal from '../../Base'

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    resume () {
      this.loading = true
      axios.put(`/api/account/bookings/${this.data.id}/resume`)
          .then(() => {
            this.$toasted.show(`Your ${this.data.booking_type_label} has been resumed.`, { type: 'success' })
            this.$emit('confirm')
            this.$eventBus.$emit('update_listing_booking-item')
          })
          .catch(error => {
            this.$toasted.show(
                `Your ${this.data.booking_type_label} could not be resumed, please refresh the page and try again.`, {
                  type: 'error'
                })
          })
          .then(() => {
            this.loading = false
          })
    },
    keep () {
      this.$emit('cancel')
    }
  }
}
</script>
